
import axios from 'axios'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { accountLogin, emailLogin } from '@/api/user'

const state = {
  user_privacy: [
    { key: 'phone', value: '', label: '手机号' },
    { key: 'email', value: '', label: '邮箱' },
    { key: 'wechatID', value: '', label: '微信' },
    { key: 'password', value: false, label: '密码' },
  ],
  person_msg: {
    uid:'',
    type:'',
    username: '',
    sex: '',
    local: {
      province: '',
      city: '',
      area: ''
    },
    school: '',
    email:'',
    account:'',
    phone:'',
    isSeller:false
  },
}
const phoneNumber = /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
const email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
const mutations = {
  LOGIN_SUCCESS_USER (state, payload) {
    switch (payload.way) {
      case 'account':state.person_msg.account=payload.account;break;
      case 'email':state.person_msg.email=payload.account;break;
    }
    localStorage.setItem('account',payload.account)
    state.person_msg.uid=payload.data.user.id
    state.person_msg.username=payload.data.user.id
    state.person_msg.type=payload.data.user.groups
    localStorage.setItem('isSeller',false)
    for(let i=0;i<payload.data.user.groups.length;i++){
      if(payload.data.user.groups[i].name=='商'){
        state.person_msg.isSeller=true
        localStorage.setItem('isSeller',true)
      }
    }
    state.user_privacy[3].value=true

    localStorage.setItem('hasPwd',true)
    localStorage.setItem('uid',payload.data.user.id)
    localStorage.setItem('username',payload.data.user.id)
    localStorage.setItem('user_type',JSON.stringify(payload.data.user.groups))
  },


  RE_LOGIN (state, payload) {
    console.log(payload)
    state.person_msg.account = payload.email || payload.account
    state.user_privacy[0].value = payload.phone
    state.user_privacy[1].value = payload.email
    state.person_msg.username = payload.username||payload.uid
    state.user_privacy[3].value = payload.hasPwd
    state.person_msg.type = payload.user_type
    state.user_token = payload.token
    state.person_msg.id = payload.uid
    state.person_msg.local.province=payload.province
    state.person_msg.local.city=payload.city
    state.person_msg.local.area=payload.area
    state.person_msg.school=payload.school
    state.person_msg.sex=payload.sex
  },


  SET_TOKEN (state, payload) {
    setToken(payload)
    localStorage.setItem('token', payload)
  },


  UPDATE_PERSONAL_MSG(state,payload){
    localStorage.setItem('sex',payload.sex)
    localStorage.setItem('province',payload.province)
    localStorage.setItem('city',payload.city)
    localStorage.setItem('area',payload.area)
    localStorage.setItem('school',payload.school)
    state.person_msg.username=payload.username
    state.person_msg.sex=payload.sex
    state.account.username=payload.username
    state.person_msg.local.area=payload.area
    state.person_msg.local.city=payload.city
    state.person_msg.local.province=payload.province
    state.person_msg.school=payload.school
    localStorage.setItem('username',payload.username)
  },


  REMOVE_TOKEN (state) {
    removeToken()
    state.user_token = ''
    for (let i = 0; i < state.user_privacy.length; i++) {
      state.user_privacy[i].value = ''
    }
    state.person_msg.school = ''
    state.person_msg.sex = ''
    state.person_msg.username = ''
    state.person_msg.local.province = ''
    state.person_msg.local.area = ''
    state.person_msg.local.city = ''
  }
}


const actions = {
  reLogin ({ commit }, payload) {
    commit("RE_LOGIN", payload)
  },

  changePersonMsg({commit},payload){
    commit("UPDATE_PERSONAL_MSG",payload)
  },

  loginSync ({ commit }, payload) {
    switch (payload.type) {
      case "email": {
        return new Promise((resolve, reject) => {
          emailLogin({email:payload.account,password:payload.password}).then(res => {
            if (res.status === 'ok') {
              commit("SET_TOKEN", res.data.auth.token)
              commit("LOGIN_SUCCESS_USER", {
                data:res.data,
                way:'email',
                account:payload.account
              })
            }
            resolve(res)
          }).catch(e => {
            console.log(e)
          })
        })
        break
      }
      case 'account':{
        return new Promise((resolve, reject) => {
            accountLogin({account:payload.account,password:payload.password}).then(res => {
            if (res.status === 'ok') {
              commit("SET_TOKEN", res.data.auth.token)
              commit("LOGIN_SUCCESS_USER", {
                data:res.data,
                way:'account',
                account:payload.account
              })
            }
            resolve(res)
          }).catch(e => {
            console.log(e)
          })
        })
        break
      }
      default: {
        return new Promise((resolve, reject) => {
          accountLogin({account:payload.account,password:payload.password}).then(res => {
            if (res.status === 'ok') {
              commit("SET_TOKEN", res.data.auth.token)
              commit("LOGIN_SUCCESS_USER", {
                data:res.data,
                way:'account',
                account:payload.account
              })
            }
            resolve(res)
          }).catch(e => {
            console.log(e)
          })
        })
      }
    }
  },

  logout ({ commit }, payload) {

    commit("REMOVE_TOKEN", payload)

  },

  getCode ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: 'https://api.xiyilab.com/v1/auth/register/auth-email',
        data: {
          email: payload,
        }
      }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  },

  getCodeChangePwd ({ state },payload) {

    return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: 'https://api.xiyilab.com/v1/auth/change-password/auth-email',
          data: {
            email: payload,
          }
        }).then(res => {
          resolve(res)
        }).catch(e => {
          reject(e)
        })
    })
  },

  changePwd ({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: 'https://api.xiyilab.com/v1/auth/change-password/email',
        data: {
          email: payload.email,
          new_password: payload.password,
          code: parseInt(payload.code)
        }
      }).then(res => {
        resolve(res.data.status)
      }).catch(e => {
        reject(e)
      })
    })
  },

  register ({ commit }, payload) {
    switch (payload.type) {
      case "email": {
        return new Promise((resolve, reject) => {
          let data = {
            email: payload.account,
            password: payload.password,
            code: parseInt(payload.code)
          }
          axios({
            method: 'post',
            url: 'https://api.xiyilab.com/v1/auth/register/email',
            data: data
          }).then(res => {
            if (res.data.status === 'ok') {
              commit("REGISTER_USER")

            }
            resolve(res.data.status)
          }).catch(e => {
            console.log(e)
          })
        })
      }
    }
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
